import React from "react";
import CTASection from "../../components/ui/CTASection";
import InsuranceForm from "../../components/templates/InsuranceForm";

const ServiceTemplate = ({
  heroImage,
  title,
  subtitle,
  color,
  icon,
  mainContent,
  coverages,
  additionalCoverages,
  advantages,
  steps,
  tip,
  artigo = "um",
  ramo,
  pageRamo,
  showEmail,
  showVeiculo,
  formUrl,
}) => {
  return (
    <>
      {/* Page Header */}
      <section
        className="bg-cover bg-center py-28"
        style={{
          backgroundImage:
            `radial-gradient(circle, rgba(60, 200, 252, 0.45) 0%, rgba(9, 25, 55, 0.9) 100%), url(${heroImage})`,
        }}
      >
        <div className="container mx-auto px-4 text-center pt-8">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {title}
          </h1>
          <p className="text-xl text-white">{subtitle}</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row gap-12">
            <div className="lg:w-2/3">
              <h2 className="text-3xl font-bold text-blue-950 mb-6">
                Por que contratar {artigo} {title}?
              </h2>
              <div className={`w-20 h-1 bg-${color}-600 mb-6`}></div>

              {mainContent.map((paragraph, index) => (
                <p key={index} className="text-gray-700 mb-6">
                  {paragraph}
                </p>
              ))}

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
                <div
                  className={`bg-white rounded-lg shadow-md p-6 border-l-4 border-${color}-600`}
                >
                  <h3 className="text-xl font-semibold text-blue-950 mb-3">
                    Coberturas Principais
                  </h3>
                  <ul className="space-y-2 text-gray-700">
                    {coverages.map((coverage, index) => (
                      <li key={index} className="flex items-center">
                        <i
                          className={`fas fa-check text-${color}-600 mr-2`}
                        ></i>
                        {coverage}
                      </li>
                    ))}
                  </ul>
                </div>

                <div
                  className={`bg-white rounded-lg shadow-md p-6 border-l-4 border-${color}-600`}
                >
                  <h3 className="text-xl font-semibold text-blue-950 mb-3">
                    Coberturas Adicionais
                  </h3>
                  <ul className="space-y-2 text-gray-700">
                    {additionalCoverages.map((coverage, index) => (
                      <li key={index} className="flex items-center">
                        <i
                          className={`fas fa-check text-${color}-600 mr-2`}
                        ></i>
                        {coverage}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-blue-950 mb-6">
                Vantagens de {artigo} {title}
              </h2>
              <div className={`w-20 h-1 bg-${color}-600 mb-6`}></div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
                {advantages.map((advantage, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-lg shadow-md p-6 text-center"
                  >
                    <div
                      className={`bg-${color}-100 p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4`}
                    >
                      <i
                        className={`fas fa-${advantage.icon} text-${color}-600 text-2xl`}
                      ></i>
                    </div>
                    <h3 className="text-lg font-semibold text-blue-950 mb-2">
                      {advantage.title}
                    </h3>
                    <p className="text-gray-600">{advantage.description}</p>
                  </div>
                ))}
              </div>

              <h2 className="text-3xl font-bold text-blue-950 mb-6">
                Como Funciona
              </h2>
              <div className={`w-20 h-1 bg-${color}-600 mb-6`}></div>

              <div className="bg-gray-50 rounded-lg p-6 mb-12">
                <ol className="space-y-6">
                  {steps.map((step, index) => (
                    <li key={index} className="flex">
                      <div
                        className={`bg-${color}-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-4 flex-shrink-0`}
                      >
                        {index + 1}
                      </div>
                      <div>
                        <h4 className="text-lg font-semibold text-blue-950 mb-1">
                          {step.title}
                        </h4>
                        <p className="text-gray-700">{step.description}</p>
                      </div>
                    </li>
                  ))}
                </ol>
              </div>

              <div
                className={`bg-${color}-50 border border-${color}-200 rounded-lg p-6 mb-8`}
              >
                <h3 className="text-xl font-semibold text-blue-950 mb-3">
                  Dica da Free Market
                </h3>
                <p className="text-gray-700">{tip}</p>
              </div>
            </div>

            <div className="lg:w-1/3">
              <div className="bg-white rounded-lg shadow-lg overflow-hidden sticky top-8">
                <div className={`bg-${color}-600 py-4 px-6`}>
                  <h3 className="text-xl font-bold text-white">
                    Solicite uma Cotação
                  </h3>
                </div>
                <div className="p-6">
                  <InsuranceForm
                    ramo={ramo}
                    pageRamo={pageRamo}
                    showEmail={showEmail}
                    showVeiculo={showVeiculo}
                    formUrl={formUrl}
                  />

                  <div className="mt-6 pt-6 border-t border-gray-200">
                    <h4 className="text-lg font-semibold text-blue-950 mb-3">
                      Contato Direto
                    </h4>
                    <div className="space-y-3">
                      <a
                        href="tel:+553436710353"
                        className="flex items-center text-gray-700 hover:text-blue-600"
                      >
                        <i className="fas fa-phone-alt text-blue-850 mr-2"></i>
                        (34) 3671-0353
                      </a>
                      <a
                        href="https://wa.me/553436710349"
                        className="flex items-center text-gray-700 hover:text-green-600"
                      >
                        <i className="fab fa-whatsapp text-green-600 mr-2"></i>
                        (34) 3671-0349
                      </a>
                      <a
                        href="mailto:seguros@freemarketseguros.com.br"
                        className="flex items-center text-gray-700 hover:text-blue-600"
                      >
                        <i className="fas fa-envelope text-blue-850 mr-2"></i>
                        contato@freemarketseguros.com.br
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <CTASection
        title={`Pronto para contratar ${artigo} ${title}?`}
        description={`Solicite uma cotação gratuita e descubra como podemos ajudar você a encontrar o ${title.toLowerCase()} ideal para suas necessidades.`}
        buttonText="Simular Agora"
        buttonLink="/simulacao"
      />
    </>
  );
};

export default ServiceTemplate;
